'use strict';

var nestedValue = require('../helpers/nestedValue');

module.exports = function whereNotBetween(key, values) {
  return this.filter(function (item) {
    return nestedValue(item, key) < values[0] || nestedValue(item, key) > values[values.length - 1];
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/whereNotBetween.js
// module id = ./node_modules/collect.js/dist/methods/whereNotBetween.js
// module chunks = 0